// 页面类型
export const pageType = {
  homePage: 'homePage', //首页
  resultPage: 'resultPage', // 储值结果页
  vipPage: 'vipPage', // vip页
  bankPage: 'bankPage', // 银行汇款页
  balancePage: 'balancePage', // 平台币余额页面
  paymentCreditPage: 'paymentCreditPage', //信用卡独立支付页
  browserPay: 'browserPay' // 储值结果跳转页
};

// 弹窗类型
export const popupType = {
  loginPopup: 'loginPopup', // 登录弹窗
  charPopup: 'charPopup', // 角色弹窗
  gameCouponPopup: 'gameCouponPopup', // 游戏优惠券弹窗
  vipCouponPopup: 'vipCouponPopup', // vip优惠券弹窗
  birthCouponPopup: 'birthCouponPopup', // 生日优惠券弹窗
  paytypeCouponPopup: 'paytypeCouponPopup', // 支付渠道优惠券弹窗
  eventlistPopup: 'eventlistPopup', // 福利弹窗
  aboutCurrencyPopup: 'aboutCurrencyPopup', // 关于代金币弹窗
  safariAddToHomePopup: 'safariAddToHomePopup', // safari添加到主屏幕弹窗
  couponUseCheckPopup: 'couponUseCheckPopup', // 优惠券使用确认弹窗
  pointCardPopup: 'pointCardPopup', // 点卡弹窗
  paytypeAreaPopup: 'paytypeAreaPopup', // 支付渠道区域弹窗
  productPopup: 'productPopup', // 商品选择弹窗
  errorPaytypePopup: 'errorPaytypePopup', // 支付渠道错误弹窗
  doubleSendPopup: 'doubleSendPopup', // 双倍券弹窗
  coinBalancePopup: 'coinBalancePopup', // 代金币余额不足弹窗
  quickPayCardSelectPopup: 'quickPayCardSelectPopup', // 选择支付卡弹窗
  pwaInstallPopup: 'pwaInstallPopup', // pwa安装弹窗
  pwaBindRolePopup: 'pwaBindRolePopup', // pwa绑定角色弹窗
  rightCenterPopup: 'rightCenterPopup', // 权益中心弹窗
  confirmProductPopup: 'confirmProductPopup', // 确认商品弹窗
  showProductDetailPopup: 'showProductDetailPopup' // 查看商品详情弹窗
};

// 按钮触发位置
export const locationType = {
  ...pageType,
  ...popupType,
  accountInfo: 'account_info', // 帐号信息模块
  paytypeSection: 'select_channels', // 选择支付渠道模块
  eventList: 'event_list', // 活动列表弹窗
  mainBar: 'mainbar', // 主页功能入口
  selectProduct: 'select_product', // 选择商品模块
  areaLimit: 'change_regions', //切换地区弹窗
  areaLimitConfirm: 'confirm_regions', //确定地区弹窗
};

/**
    页面展示
    key: 页面类型key
*/
export const viewPage = key => {
  window?.webstorev2DataLayer?.push({
    eventName: 'view_page',
    eventType: pageType[key] || key || ''
  });
};

/**
    弹窗展示
    popupType: 描述弹窗类型
*/
export const showPopup = key => {
  window?.webstorev2DataLayer?.push({
    eventName: 'show_popup',
    eventType: popupType[key] || key || ''
  });
};

/**
    按钮点击
    btnName: 按钮名称
    reason: 按钮所属模块
*/
export const clickButton = ({ btnName, locationKey, otherParams }) => {
  window?.webstorev2DataLayer?.push({
    eventName: 'click_button',
    eventType: btnName || '',
    eventReason: locationType[locationKey] || locationKey || '',
    eventValue: otherParams
  });
};
